import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../../utils/api';
import HighlightCard from './HighlightCard';
import './Highlights.css';

const HighlightsList = ({ onSelectMatch }) => {
  const { t } = useTranslation();
  const [highlights, setHighlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetch(`${API_URL}/api/highlights/recent?limit=50`)
      .then(res => res.json())
      .then(data => {
        setHighlights(data.highlights || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const filteredHighlights = highlights.filter(h => {
    if (filter === 'all') return true;
    if (filter === 'ace') return h.highlight_type === 'ace';
    if (filter === 'clutch') return h.highlight_type.startsWith('clutch');
    if (filter === '4k') return h.highlight_type === '4k';
    return true;
  });

  if (loading) return <div className="loading-screen"><div className="loader"></div></div>;

  return (
    <div className="highlights-page">
      <div className="highlights-page-header">
        <h1 className="page-title">🎬 Highlights</h1>
        <div className="highlights-filters">
          <button className={`filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>{t('matches.all')}</button>
          <button className={`filter-btn ${filter === 'ace' ? 'active' : ''}`} onClick={() => setFilter('ace')}>🏆 Aces</button>
          <button className={`filter-btn ${filter === 'clutch' ? 'active' : ''}`} onClick={() => setFilter('clutch')}>🔥 Clutches</button>
          <button className={`filter-btn ${filter === '4k' ? 'active' : ''}`} onClick={() => setFilter('4k')}>⚡ 4K</button>
        </div>
      </div>

      {filteredHighlights.length === 0 ? (
        <div className="no-highlights">
          <span className="no-highlights-icon">🎬</span>
          <h2>{t('highlights.noneYet')}</h2>
          <p>{t('highlights.noneDesc')}</p>
        </div>
      ) : (
        <div className="highlights-grid">
          {filteredHighlights.map(highlight => (
            <HighlightCard key={highlight.id} highlight={highlight} onClick={onSelectMatch} />
          ))}
        </div>
      )}
    </div>
  );
};

export default HighlightsList;
